import type { FC } from 'react';
import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl-next';

import NoResultIcon from './no-results.svg';
import {
	MessageContainer,
	MessageMain,
	MessageSecondary,
} from './SpaceCustomContentListView-styles';
import { i18n } from './SpaceCustomContentListView-i18n';

export const CustomContentEmptyList: FC<{}> = () => {
	const intl = useIntl();
	return (
		<MessageContainer>
			<img src={NoResultIcon} alt={intl.formatMessage(i18n.noItems)} />
			<MessageMain>
				<FormattedMessage {...i18n.noCustomContent} />
			</MessageMain>
			<MessageSecondary>
				<FormattedMessage {...i18n.timeToFill} />
			</MessageSecondary>
		</MessageContainer>
	);
};
